import { useState, useRef, useEffect } from "react";
import { Button } from "../../ui/Button";
import styles from "./StippetCreator.module.css";

export function StippetCreator({ onNewStippet, currentWorld }) {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const titleRef = useRef(null);

  useEffect(
    function () {
      if (isOpen) {
        titleRef.current.focus();
      }
    },
    [isOpen]
  );

  function handleCreatorPanelToggle(event) {
    event.preventDefault();
    setIsOpen((prevIsOpen) => !prevIsOpen);
    setBody("");
    setTitle("");
  }

  function saveStory(event) {
    event.preventDefault();

    if (!title || !body) return;

    const newStory = {
      id: crypto.randomUUID(),
      title: title,
      body: body,
      world: currentWorld,
    };

    onNewStippet(newStory);
    setBody("");
    setTitle("");
    setIsOpen(false);
  }

  return isOpen ? (
    <form onSubmit={saveStory} className={styles.stippetCreator}>
      <div className={styles.inputGrid}>
        <div className={styles.inputGroup}>
          <label htmlFor="stippet-title">Title</label>
          <input
            id="stippet-title"
            className={styles.titleInput}
            type="text"
            placeholder="e.g. The clocktower bargain"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            ref={titleRef}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
              }
            }}
          ></input>
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="stippet-body">Story</label>
          <textarea
            id="stippet-body"
            className={styles.bodyInput}
            placeholder="Tell your tale..."
            value={body}
            onChange={(event) => setBody(event.target.value)}
            rows={10}
          ></textarea>
        </div>
      </div>
      <div className={styles.creatorActions}>
        <Button variant="ghost" type="button" onClick={handleCreatorPanelToggle}>
          Cancel
        </Button>
        <Button variant="primary" type="submit">
          Save stippet
        </Button>
      </div>
    </form>
  ) : (
    <Button variant="primary" fullWidth onClick={handleCreatorPanelToggle}>
      Add new stippet
    </Button>
  );
}
